/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Archive Icon
 *
 * @file ArchiveIcon.jsx
 * @author Gladson Samuel S
 * @since 3.2.4
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import PropTypes from 'prop-types';

export default function ArchiveIcon({ sx, ...props }) {
  return (
    <SvgIcon
      {...props}
      // MUI's SvgIcon CSS sets fill: currentColor, which beats the fill attribute
      sx={{ fill: 'none', ...sx }}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#5B57A6"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="4" width="18" height="5" rx="1" />
      <path d="M5 9v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9" />
      <path d="M10 13h4" />
    </SvgIcon>
  );
}

ArchiveIcon.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func])
};

ArchiveIcon.defaultProps = {
  sx: undefined
};
